import { useMatch } from "react-router";

import { AppRoutes } from "@/router/AppRoutes";

export function useClientId() {
  return useMatch(`${AppRoutes.Clients}/:id/*`)?.params.id;
}
